import { Directive, inject, TemplateRef } from '@angular/core';
import { IMatrixGridCellContext, IMatrixGridFooterContext, IMatrixGridHeaderContext } from './matrix-grid.interface';

@Directive({ selector: 'ng-template[matrixHeaderDef]' })
export class MatrixHeaderDefDirective<TColumn> {
  public readonly template = inject<TemplateRef<IMatrixGridHeaderContext<TColumn>>>(TemplateRef);
}

@Directive({ selector: 'ng-template[matrixCellDef]' })
export class MatrixCellDefDirective<TRow, TColumn> {
  public readonly template = inject<TemplateRef<IMatrixGridCellContext<TRow, TColumn>>>(TemplateRef);
}

/** Rendered under the cell content of an expanded row, inside the same cell so it lines up per column. */
@Directive({ selector: 'ng-template[matrixExpandedDef]' })
export class MatrixExpandedDefDirective<TRow, TColumn> {
  public readonly template = inject<TemplateRef<IMatrixGridCellContext<TRow, TColumn>>>(TemplateRef);
}

@Directive({ selector: 'ng-template[matrixFooterDef]' })
export class MatrixFooterDefDirective<TColumn> {
  public readonly template = inject<TemplateRef<IMatrixGridFooterContext<TColumn>>>(TemplateRef);
}
